import React, { useState, useEffect } from "react";
import TeacherMenu from "./TeacherMenu";
import ShowStaff from "../Shared/ShowStaff";
import { NavLink } from "react-router-dom";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MonthsDropDown from "../Shared/MonthsDropDown";
import moment from "moment";

function TeacherDashboard(props) {
  const [AccessKey, setAccessKey] = useState(
    localStorage.getItem("AccessKey")
  );
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );

  const staffId = parseInt(UserID, 10) || 0;

  const [employeeName, setEmployeeName] = useState("");
  const [loadingLeaves, setLoadingLeaves] = useState(false);
  const [leaves, setLeaves] = useState([]);

  const [leaveMode, setLeaveMode] = useState("month"); // 'month' | 'year'
  const [SelectedMonth, setSelectedMonth] = useState(moment().format("M"));
  const [SelectedYear] = useState(moment().format("YYYY"));

  useEffect(() => {
    if (!AccessKey || !staffId) return;

    const data = {
      AccessKey: AccessKey,
      UserID: staffId,
      ID: staffId,
      MemberType: MemberType || "Teacher",
    };

    axios({
      method: "post",
      url: config.base_url + "Payroll/GetEmployeeByID",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        const sc = response.data?.status_code;
        if (sc === 1 || sc === "1") {
          setEmployeeName(response.data.Employee?.Name || "");
        } else {
          setEmployeeName("");
          toast.error(
            response.data?.status_message || "Failed to load staff name.",
            { position: toast.POSITION.TOP_RIGHT }
          );
        }
      })
      .catch(() => {
        setEmployeeName("");
      });
  }, [AccessKey, staffId, MemberType]);

  useEffect(() => {
    if (!AccessKey || !staffId) return;

    const monthVal = leaveMode === "month" ? parseInt(SelectedMonth, 10) : 0;
    const yearVal = parseInt(SelectedYear, 10) || moment().year();

    setLoadingLeaves(true);
    setLeaves([]);

    const data = {
      AccessKey: AccessKey,
      UserID: staffId,
      MemberType: MemberType || "Teacher",
      ID: staffId,
      SelectedMonth: monthVal,
      FYear: yearVal,
    };

    axios({
      method: "post",
      url: config.base_url + "Payroll/GetEmployeeLeavesByMonthYear",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then((response) => {
        const sc = response.data?.status_code;
        if (sc === 1 || sc === "1") {
          setLeaves(response.data?.ListofRecords || []);
        } else {
          toast.error(
            response.data?.status_message || "No leave records found.",
            { position: toast.POSITION.TOP_RIGHT }
          );
        }
      })
      .catch(() => {
        toast.error("Network Error while loading leaves.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      })
      .finally(() => setLoadingLeaves(false));
  }, [
    AccessKey,
    staffId,
    MemberType,
    leaveMode,
    SelectedMonth,
    SelectedYear,
  ]);

  return (
    <>
      <TeacherMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/teacher/dashboard">Home</NavLink>
                    </li>
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      Teacher Dashboard
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Teacher Dashboard</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <ShowStaff EmployeeID={UserID} />

            <div className="card">
              <div className="card-body">
                <div className="row g-3 align-items-end mb-2">
                  <div className="col-md-4">
                    <b>Leaves</b>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label mb-1">Show For</label>
                    <select
                      className="form-select"
                      value={leaveMode}
                      onChange={(e) => setLeaveMode(e.target.value)}
                    >
                      <option value="month">This Month</option>
                      <option value="year">This Year</option>
                    </select>
                  </div>
                  {leaveMode === "month" && (
                    <div className="col-md-4">
                      <label className="form-label mb-1">
                        Select Month
                      </label>
                      <select
                        className="form-select"
                        value={SelectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                      >
                        <MonthsDropDown />
                      </select>
                    </div>
                  )}
                </div>

                <table className="table table-theme">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Staff Name</th>
                      <th>Description</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingLeaves ? (
                      <tr>
                        <td colSpan={4} className="text-center">
                          <Spinner animation="border" role="status" />
                        </td>
                      </tr>
                    ) : leaves && leaves.length > 0 ? (
                      leaves.map((item) => (
                        <tr key={item.ID}>
                          <td>{item.ID}</td>
                          <td>{employeeName || "-"}</td>
                          <td>{item.Description}</td>
                          <td>{item.Amount}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">
                          No Leave Records Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TeacherDashboard;